import apiProvider from './utilities/provider'

/**
 * v2 auth identity bootstrap. Returns the server-resolved current-user identity
 * (id, company, role, ...). The httpOnly token cookie is sent automatically
 * (withCredentials); no token handling on the client.
 */
const apiUserInfo = {
  get: (config) => apiProvider.getAll('v2/auth/user-info', config),
}

export default apiUserInfo
